import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router';

import ActionButton from '@/components/ActionButton/index.ts';
import { LANG } from '@/services/Config.js';

import data from './data.json';

const BoxContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(2),
  padding: theme.spacing(5),
  paddingTop: theme.spacing(4),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    paddingBottom: theme.spacing(5),
  },
}));

const StyledTitle = styled('p')(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 700,
  fontSize: '25px',
  width: '80%',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '22px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '19px',
    width: '100%',
  },
}));

const StyledActionButton = styled(ActionButton)(({ theme }) => ({
  minWidth: 300,
  maxWidth: 300,
  maxHeight: 60,
  fontSize: '19px',
  width: '100%',
  backgroundColor: '#FA8331',
  borderColor: '#FA8331',
  color: '#fff',
  '&:hover': {
    borderColor: '#FA8331',
    color: '#FA8331',
  },
  [theme.breakpoints.up(395)]: {
    minWidth: 300,
  },
  [theme.breakpoints.up('sm')]: {
    minWidth: 300,
    maxHeight: 70,
  },
  [theme.breakpoints.up('md')]: {
    minWidth: 300,
  },
}));

const ItemsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  width: '55%',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('lg')]: {
    width: '65%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
}));

const Item = styled('li')(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
}));

const RulesText = styled('div')(({ theme }) => ({
  color: '#354661',
  fontSize: '19px',
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
  display: 'inline-block',
}));

const Description6Component = () => {
  const navigate = useNavigate();
  const { routes } = LANG;

  return (
    <BoxContainer>
      <StyledTitle className="typography-v1-body1">På Scoopr får du oversikt over</StyledTitle>

      <ItemsContainer>
        {data.rules.map((text) => (
          <Item key={text.index}>
            <RulesText className="typography-v1-legacy-p1">
              <div dangerouslySetInnerHTML={{ __html: text.text }} />
            </RulesText>
          </Item>
        ))}
      </ItemsContainer>

      <StyledActionButton
        label="Min Scoopr"
        color="secondary"
        onClick={() => {
          void navigate(routes.MY_SCOOPR_LOGIN);
        }}
        labelClassName="action-button-text"
        sx={{
          '& .action-button-text': {
            width: '80%',
            fontSize: {
              xs: '19px',
              md: '22px',
            },
          },
        }}
      />
    </BoxContainer>
  );
};

export default Description6Component;
